<div class="background-color-yellow">
    <app-nav class="_sticky _top-0 _z-50 _block _border-b">
        <div slot="consumer-search" *ngIf="!mobileView && isWhiteLabel">
            <app-search-criteria
                    layout="row"
                    [aiSearchEnabled]="true"
                    [aiSearchInitWithValue]="initWithAiSearch"
                    [disabled]="loading"
                    [minimumConsecutiveNights]="minimumConsecutiveNights"
                    (criteria)="search($event)"
                    (setInitCriteria)="setCriteria($event)"
                    [showModalFilters]="false"
                    (activeRegion)="requestPanning($event)"
                    (searchRegionName)="updateSearchRegionName($event)"
                    (aiSearchActive)="aiSearchMode = $event">
            </app-search-criteria>
        </div>
        <div slot="ta-search" *ngIf="!mobileView && !isWhiteLabel">
            <app-search-criteria
                    layout="row"
                    [aiSearchEnabled]="true"
                    [aiSearchInitWithValue]="initWithAiSearch"
                    [disabled]="loading"
                    [minimumConsecutiveNights]="minimumConsecutiveNights"
                    (criteria)="search($event)"
                    (setInitCriteria)="setCriteria($event)"
                    [showModalFilters]="false"
                    (activeRegion)="requestPanning($event)"
                    (searchRegionName)="updateSearchRegionName($event)"
                    (aiSearchActive)="aiSearchMode = $event">
            </app-search-criteria>
        </div>
    </app-nav>

    <div *ngIf="travelAgentView" class="search-v3">

        <!-- mobile search criteria drawer -->
        <div *ngIf="mobileView"
             class="_drawer _drawer-no-toggle-btn _p-4"
             [ngClass]="{ '_drawer-open': showMobileSearchCriteria }">
            <div class="_relative _h-full _overflow-y-scroll _no-scrollbar _p-nudge-2 _pb-20">
                <div class="_flex _justify-end _mb-4">
                    <button class="_button-reset _pr-0"
                            (click)="closeMobileSearchCriteriaDrawer()">
                        <i class="fa-sharp fa-light fa-chevrons-right"></i>
                    </button>
                </div>

                <div class="sm-max:_max-w-600px _mx-auto">
                    <app-search-criteria
                            layout="col"
                            [disabled]="loading"
                            [minimumConsecutiveNights]="minimumConsecutiveNights"
                            (criteria)="search($event)"
                            (setInitCriteria)="setCriteria($event)"
                            [showModalFilters]="false"
                            (activeRegion)="requestPanning($event)"
                            [activeFilter]="activeSearchCriteria"
                            (searchRegionName)="updateSearchRegionName($event)"
                            (aiSearchActive)="aiSearchMode = $event">
                    </app-search-criteria>
                </div>

                <div class="_flex _justify-between _bg-white _items-center _p-3 _shadow-top _fixed _bottom-0 _left-0 _w-full _z-10">
                    <div class="_text-primary-1-tint-50 _cursor-pointer"
                         (click)="resetSearchCriteria()">
                        <span class="_text-md _mr-2 _text-primary-1">Clear all</span>
                        <i class="fa-light fa-arrows-rotate _text-md"></i>
                    </div>
                    <button
                            class="_button-primary"
                            (click)="closeMobileSearchCriteriaDrawer()">
                        Search luxury
                    </button>
                </div>
            </div>
        </div>

        <!-- mobile text search drawer -->
        <div *ngIf="mobileView"
             class="_drawer _drawer-no-toggle-btn _p-4"
             [ngClass]="{ '_drawer-open': showMobileSearchByText }">
            <div class="_relative _h-full _overflow-y-scroll _no-scrollbar _p-nudge-2 _pb-0">
                <div class="_flex _justify-end _mb-4">
                    <button class="_button-reset _pr-0"
                            (click)="showMobileSearchByText = false">
                        <i class="fa-sharp fa-light fa-chevrons-right"></i>
                    </button>
                </div>

                <div class="sm-max:_max-w-600px _mx-auto">
                    <app-search-text
                            [inline]="true"
                            [columnLayout]="true"
                            [collapsableSearchInput]="false"
                            (locationSelectedEvent)="showMobileSearchByText = false"
                            (locationSelectedEvent)="requestPanning($event)">
                    </app-search-text>
                </div>
            </div>
        </div>

        <!-- mobile search filters drawer -->
        <div *ngIf="mobileView"
             class="_drawer _drawer-no-toggle-btn"
             [ngClass]="{ '_drawer-open': showMobileSearchFilters }">
            <div class="_relative _h-full _overflow-y-scroll _no-scrollbar  _pb-20">
                <div class="_flex _justify-between _items-center _mb-4 _p-3 _shadow-bottom _sticky _top-0 _bg-white _z-50">
                    <span>
                        More Filters
                        <span *ngIf="selectedFiltersCount"
                              class="_text-primary-1-tint-50 _text-md"> ({{ selectedFiltersCount }} selected)</span>
                    </span>
                    <button class="_button-reset _pr-0"
                            (click)="closeMobileSearchFiltersDrawer()">
                        <i class="fa-sharp fa-light fa-chevrons-right"></i>
                    </button>
                </div>

                <div class="sm-max:_max-w-600px _mx-auto _p-4 _pt-3">
                    <app-search-filters
                            layout="col"
                            [listingsOnMapCount]="listingsOnMapCount"
                            [minimumConsecutiveNights]="minimumConsecutiveNights"
                            (criteria)="search($event)"
                            ($selectedFilterCountChanged)="updateSelectedFiltersCount($event)">
                    </app-search-filters>
                </div>

                <div class="_flex _justify-between _bg-white _items-center _p-3 _shadow-top _fixed _bottom-0 _left-0 _w-full _z-10">
                    <div class="_text-primary-1-tint-50 _cursor-pointer"
                         (click)="clearAllFilters()">
                        <span class="_text-md _mr-2 _text-primary-1">Clear all</span>
                        <i class="fa-light fa-arrows-rotate _text-md"></i>
                    </div>
                    <button
                            class="_button-primary"
                            (click)="closeMobileSearchFiltersDrawer()">
                        View {{ listingsOnMapCount }} listings
                    </button>
                </div>
            </div>
        </div>

        <app-search-filters
            *ngIf="!mobileView"
            layout="row"
            [disabled]="aiSearchMode"
            [listingsOnMapCount]="listingsOnMapCount"
            [minimumConsecutiveNights]="minimumConsecutiveNights"
            (criteria)="search($event)">
        </app-search-filters>

        <div class="_m-0 _border-0">
            <div class="search-listing-main-container _bg-primary-1-tint-20 sm:_bg-grayscale-white">
                <div class="search-map-container"
                     [ngClass]="mobileView && mobileViewActive !=='map' ? '_h-0 _w-0 _opacity-0 _fixed _overflow-hidden' : '_relative'">
                    <app-search-map
                        [initMapBoundingBox]="initMapBoundingBox"
                        (boundsChanged)="updateBounds($event)"
                        (numberOfMarkersVisible)="updateListingCount($event)"
                        [searchMetadata$]="searchMetadata$"
                        [listingMapMarkers$]="listings$"
                        [hoveredListingId$]="hoveredListingId$">
                        <div *ngIf="searching"
                             class="_text-md _absolute _top-4 _left-1/2 _transform _-translate-x-1/2 _pill _bg-grayscale-black _shadow-light">
                            Searching...
                        </div>
                        <div class="_absolute _top-2 _right-2">
                            <div class="_relative">
                                <div class="_relative"
                                    (mouseenter)="showInquiryBanner = true"
                                    (mouseleave)="showInquiryBanner = false">
                                    <app-property-inquiry
                                        [useCustomContentCta]="true"
                                        headingText=""
                                        bodyText="">
                                        <button class="_button-secondary _shadow _px-2 _py-1">
                                            <i class="fa-duotone fa-solid fa-binoculars _text-xl"></i>
                                        </button>
                                    </app-property-inquiry>
                                    <div [ngClass]="!showInquiryBanner ? '_opacity-0' : '_opacity-100'"
                                         class="_bg-green-600 _text-white _text-sm _rounded-rounded _shadow _border _border-green-700 _w-max _absolute _py-1 _px-2 _right-100% _center-y-absolute _mr-1 _transition-all-fast">
                                        Looking for something specific?
                                    </div>
                                </div>
                            </div>
                        </div>
                    </app-search-map>
                </div>

                <div *ngIf="criteria"
                     class="listings-container padding-horizontal-2 sm-max:_w-full sm-max:_max-w-600px _mx-auto"
                     [ngClass]="{ '_hidden' : mobileView && mobileViewActive !=='listings'}">
                    <div *ngIf="criteria && (listings$ | async) as listings" class="_relative">
                        <ng-container *ngIf="listingsOnMapCount === 0 && !loading && !searching && !aiSearchMode">
                            <div class="_bg-primary-1-tint-4 _my-4 _rounded _p-4">
                                <div class="_flex _justify-between">
                                    <div class="_text-lg _pb-1 _w-3/5">There is no accommodation matching all your
                                        filters.
                                    </div>
                                    <div class="_link _cursor-pointer" (click)="clearAllFilters()">
                                        <span class="_text-sm">Clear all filters </span>
                                        <i class="fa-light fa-arrows-rotate _text-md"></i>
                                    </div>
                                </div>
                                <div class="_text-md _pt-2">You can find near-matches by:</div>
                                <ul class="_text-sm _pl-4 _pt-2">
                                    <li class="_underline _pb-1">Removing filters</li>
                                    <li class="_underline _pb-1">Reducing your number of guests</li>
                                    <li class="_underline _pb-1">Changing your dates</li>
                                </ul>
                            </div>
                            <div class="_bg-primary-1-tint-4 _my-4 _rounded _p-4">
                                <app-property-inquiry></app-property-inquiry>
                            </div>
                        </ng-container>

                        <div class="_mt-3 _mb-3 sm:_mt-8 sm:_mb-4">
                            <div *ngIf="searching || loading" class="_flex _items-center">
                                <i class="fas fa-circle-notch fa-spin"></i>
                                <span class="_text-md _ml-1">Loading</span>
                            </div>
                            <div *ngIf="!searching && !loading"
                                 class="_flex _flex-wrap _justify-between _gap-1 _text-md">
                                <div *ngIf="!aiSearchResults">Showing <span class="_font-bold">{{ listingsOnMapCount }}</span> of <span class="_font-bold">{{ total }}</span> listings</div>
                                <div *ngIf="aiSearchResults">Showing <span class="_font-bold">{{ total }}</span> listings</div>
                                <div *ngIf="total > 0 && listingsOnMapCount == 0 && !loading && !aiSearchResults" class="_font-bold">Showing recommended options</div>
                                <div class="_font-bold" *ngIf="total > 0 && aiSearchResults && !loading">Recommended AI search results</div>
                                <div>Page <span class="_font-bold">{{ p }}</span> of <span class="_font-bold">{{ pTotal }}</span></div>
                            </div>
                        </div>
                        <ng-container *ngIf="loading || searching">
                            <app-empty-state-screen [placeholderCards]="5"></app-empty-state-screen>
                        </ng-container>
                        <ng-container *ngIf="!loading && !searching">
                            <app-search-listing
                                (mouseleave)="focusListing('')"
                                (mouseenter)="focusListing(listing.listingId)"
                                [searchMetadata$]="searchMetadata$"
                                [index]="index"
                                [searchListing]="listing"
                                [checkin]="checkin"
                                [checkout]="checkout"
                                [minimumConsecutiveNights]="minimumConsecutiveNights"
                                [consumerView]="consumerView"
                                *ngFor="let listing of listings$ | async | paginate: { id: 'search-pagination', itemsPerPage: criteria.paging.size, currentPage: p, totalItems: total }; let index = index">
                            </app-search-listing>
                        </ng-container>
                    </div>

                    <div *ngIf="criteria && !loading && !searching && !!count"
                         class="_m-10 _flex _flex-row _items-center _justify-center search-pagination">
                        <pagination-template
                                #p="paginationApi"
                                id="search-pagination"
                                maxSize="8"
                                (pageChange)="getPage($event)">
                            <div *ngIf="p.pages.length > 1" class="_flex _gap-5 _items-center _text-md">
                                <div *ngIf="!p.isFirstPage()"
                                     (click)="p.previous()"
                                     class="_cursor-pointer">
                                    <i class="fa-light fa-chevron-left"></i>
                                </div>
                                <div *ngFor="let page of p.pages"
                                     [class.current]="p.getCurrent() === page.value">
                                    <div class="_cursor-pointer" (click)="p.setCurrent(page.value)"
                                         *ngIf="p.getCurrent() !== page.value">
                                        <span>{{ page.label }}</span>
                                    </div>
                                    <div *ngIf="p.getCurrent() === page.value">
                                        <span class="_pill-circle _h-6 _w-6 _bg-grayscale-black _color-grayscale-white">{{ page.label }}</span>
                                    </div>
                                </div>
                                <div *ngIf="!p.isLastPage()" (click)="p.next()" class="_cursor-pointer">
                                    <i class="fa-light fa-chevron-right"></i>
                                </div>
                            </div>
                        </pagination-template>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="mobileView"
             class="_fixed _bottom-0 _left-0 _h-20 _w-full _bg-white _z-10 _border-t _border-transparency-black-25 _shadow-top">

            <div class="_relative _w-full _h-full">
                <div *ngIf="listingsScrolled"
                     class="scroll-to-top-btn _fixed _right-5 _bottom-25 _cursor-pointer _bg-transparency-white-80 _shadow"
                     (click)="scrollToTop()">
                    <i class="fa-light fa-circle-chevron-up _text-h3-m _leading-none"></i>
                </div>
                <div class="_flex _justify-evenly _items-center _w-40 _h-8 _p-nudge-2 _center-x-absolute _-top-6 _text-md-m _rounded-md">
                    <div class="_absolute _top-0 _left-0 _w-full _h-6 _bg-white _rounded-tl-md _rounded-tr-md _border-t _border-l _border-r _border-transparency-black-25 _shadow-top"></div>
                    <div class="_cursor-pointer _flex-1 _h-full _flex _items-center _justify-center _p-0 _z-10"
                         [ngClass]="{ '_chip-dark' : mobileViewActive === 'listings' }"
                         (click)="showView('listings')">
                        <span><i class="fa-light fa-list _mr-1"></i> List</span>
                    </div>
                    <div class="_cursor-pointer _flex-1 _h-full _flex _items-center _justify-center _p-0 _z-10"
                         [ngClass]="{ '_chip-dark' : mobileViewActive === 'map' }"
                         (click)="showView('map')">
                        <span><i class="fa-light fa-map _mr-1"></i> Map</span>
                    </div>
                </div>
                <div class="_flex _h-full _text-sm-m">
                    <div class="_flex _flex-col _flex-grow _gap-1 _justify-center _px-4 _transition-all-medium"
                         [ngClass]="{'_opacity-0 _pointer-events-none' : aiSearchMode}">
                        <div class="_cursor-pointer _text-sm"
                             (click)="openMobileSearchCriteriaDrawer('region')">
                            <i class="fa-light fa-map-location _mr-2 _w-3"></i>
                            <span *ngIf="!searchRegionName"
                                  class="_text-primary-1-tint-50 _underline">All destinations</span>
                            <span *ngIf="searchRegionName" class="_text-black _underline">{{ searchRegionName }}</span>
                        </div>
                        <div class="_cursor-pointer"
                             (click)="openMobileSearchCriteriaDrawer('date')">
                            <i class="fa-light fa-calendar-days _mr-2 _w-3"></i>
                            <span class="_text-primary-1-tint-50 _text-sm">
                                <span *ngIf="!checkin && !checkout" class="_underline">Add dates </span>
                                <span *ngIf="checkin"
                                      class="_text-black _underline">{{ checkin | date:'dd MMM ' }}</span>
                                <span *ngIf="checkin || checkout" class="_text-black"> - </span>
                                <span *ngIf="checkout"
                                      class="_text-black _underline">{{ checkout | date:'dd MMM ' }}</span>
                            </span>
                        </div>
                        <div class="_cursor-pointer"
                             (click)="openMobileSearchCriteriaDrawer('guests')">
                            <i class="fa-light fa-family _mr-2 _w-3"></i>
                            <span *ngIf="totalGuests === 1"
                                  class="_text-primary-1-tint-50 _text-sm _underline">{{ totalGuests }} guest</span>
                            <span *ngIf="totalGuests > 1" class="_text-black _text-sm _underline">{{ totalGuests }}
                                guests</span>
                        </div>
                    </div>
                    <div class="_flex _items-center _p-4 _gap-2">
                        <app-search-ai
                                placeholderText="Describe your perfect stay..."
                                inputModifierClasses="_center-xy-absolute _max-w-90%"
                                (onSearchInput)="aiSearch($event)"
                                (onSearchActivated)="toggleAiSearch($event)">
                        </app-search-ai>
                        <div class="_w-7 _h-7 _flex _items-center _justify-center _cursor-pointer _bg-primary-1 _rounded-full hover:_bg-primary-3 _transition-all-medium"
                             [ngClass]="{'opacity-0 _pointer-events-none' : aiSearchMode}"
                             (click)="showMobileSearchByText = true">
                            <i class="fa-solid fa-magnifying-glass _text-white"></i>
                        </div>
                        <div class="_relative" [ngClass]="{'_opacity-0 _pointer-events-none' : aiSearchMode}">
                            <div *ngIf="selectedFiltersCount"
                                 class="_pill-circle _absolute _-right-2 _-top-nudge-7 _h-5 _w-5 _p-0 _text-xs _z-10">
                                <span>{{ selectedFiltersCount }}+</span>
                            </div>
                            <button class="_button-secondary"
                                    (click)="openMobileSearchFiltersDrawer()">
                                <i class="fa-light fa-sliders"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
